/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { FlexRow, SLNotification, Spacer } from "../../components/core/utility";
import styled from "styled-components";
import { Accordion, AccordionTab } from "primereact/accordion";
import { OrderShippingSummaryGrid } from "./OrderShippingSummaryGrid";
import { getOrderSummaryList } from "../../services/C4S Decommission - Replacement/getOrderSummaryList";

import { generate } from "shortid";
import useOutsideClick from "../../customHook/use-outside-click";
import { Loader } from "@vds/loaders";

export const AccordionStyle = styled.div`
  .p-accordion {
    margin: 0;
    padding: 0;
  }
  .p-accordion .p-accordion-header {
    min-width: 0;
    max-width: 500px;
    width: 500px;
    background: #ffffff;
    border: none !important;
    box-shadow: none;
    display: flex;
    align-items: center;
    margin: 0;
    padding-left: 0;
    transition: border-bottom 0.2s;
  }
  .p-accordion .p-accordion-header.p-highlight {
    border-bottom: none !important;
    background: #ffffff;
    color: #000000;
    box-shadow: none;
  }
  .p-accordion .p-accordion-header:not(.p-disabled):hover,
  .p-accordion .p-accordion-header:not(.p-disabled):focus {
    background: #ffffff;
    color: #000000;
    box-shadow: none;
  }
  .p-accordion .p-accordion-header .p-accordion-toggle-icon {
    margin-left: 8px;
    order: 1;
  }
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header:hover .p-accordion-header-link,
  .p-accordion .p-accordion-tab .p-accordion-header .p-accordion-header-link {
    color: #000000;
    border: none;
    padding: 0.5rem 0;
    box-shadow: unset;
    box-color: #ffffff;
    border-radius: unset;
    background: #ffffff;
    margin: 0;
  }
  .p-accordion .p-accordion-content {
    padding: 0rem;
    border: none;
  }
  .p-accordion-header-text {
    font-weight: 700;
    font-family: Verizon-NHG-eDS;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderTitle = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`;

const FulfillmentTickets = styled.div`
  font-weight: 400;
  font-size: 12px;
  text-align: right;
  margin-left: 100%;
  min-width: 407px;
`;

const CustomNotification = styled(SLNotification)`
  & div {
    justify-content: flex-start;
    max-width: 100%;
    & span:first-child {
      flex: 2 1 0%;
    }
  }
`;

export const OrderShippingSummaryAccordion = () => {
  const cspSessionData = JSON.parse(sessionStorage.getItem("CSPDetails"));
  const providerOrder = cspSessionData?.CSP.length ? cspSessionData?.CSP.filter((csp) => csp.DefaultCSP === "1")[0].Provider_Order : "";
  const [activeIndex, setActiveIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState(null);
  const [orderSummaryList, setOrderSummaryList] = useState([]);

  useEffect(() => {
    if (activeIndex === 0) {
      getOrderSummary();
    }
  }, [activeIndex]);

  const getOrderSummary = async () => {
    let userAccountId = cspSessionData?.AccountID;
    let userId = sessionStorage.getItem("userId");
    let cspId = cspSessionData?.CSP.length ? cspSessionData?.CSP.filter((csp) => csp.DefaultCSP === "1")[0].CSPID : "";
    if (userAccountId && userAccountId !== "" && userId && userId !== "" && cspId && cspId !== "" && providerOrder !== "") {
      setIsLoading(true);
      let payload = {
        accountId: cspSessionData?.AccountID,
        userId: sessionStorage.getItem("userId"),
        id: cspSessionData?.CSP.length ? cspSessionData?.CSP.filter((csp) => csp.DefaultCSP === "1")[0].CSPID : "",
        order: providerOrder,
      };
      let response = await getOrderSummaryList(payload);
      if (response.status === 200 && response.data?.data) {
        const rawBundles = response.data.data?.orderSummary?.bundles || [];
        const filteredBundles = rawBundles
          .map((b) => ({
            ...b,
            summaryLines: (b.summaryLines || []).filter((line) => line.mmidType.toLowerCase() !== "service"),
          }))
          .filter((b) => b.summaryLines.length > 0);
        setOrderSummaryList(filteredBundles);
      } else {
        notify("We are currently experiencing issues, please try again", "error", false);
      }
      setIsLoading(false);
    }
  };

  const handleClickOutside = () => {
    setNotification(null);
  };

  const clickRef = useOutsideClick(handleClickOutside);

  const notify = (content, type, isNotificationWithTimer = true) => {
    setNotification(
      <>
        <CustomNotification key={generate()} type={type} title={content} fullBleed={true} ref={clickRef} /> <Spacer bottom="10px"></Spacer>
      </>
    );
    if (isNotificationWithTimer) {
      setTimeout(() => {
        setNotification(null);
      }, 5000);
    }
  };

  return (
    <FlexRow style={{ width: "auto" }}>
      {notification}
      <Loader active={isLoading} fullscreen />
      <AccordionStyle>
        <Accordion
          expandIcon="pi pi-chevron-up"
          collapseIcon="pi pi-chevron-down"
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <AccordionTab
            key={1}
            headerTemplate={(options) => (
              <HeaderWrapper style={{ width: activeIndex === 0 ? "40%" : "100%" }}>
                <HeaderTitle>
                  <b>Order Shipping Summary</b>
                </HeaderTitle>
                {activeIndex === 0 && <FulfillmentTickets>Fulfillment Tickets</FulfillmentTickets>}
              </HeaderWrapper>
            )}
          >
            <OrderShippingSummaryGrid rows={orderSummaryList} />
          </AccordionTab>
        </Accordion>
      </AccordionStyle>
    </FlexRow>
  );
};

export default OrderShippingSummaryAccordion;
